export async function cleanupServiceWorkersInProd() {
  try {
    if (typeof window === 'undefined') return;
    const isProd = process.env.NODE_ENV === 'production';
    if (!isProd) return;

    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      if (Array.isArray(regs) && regs.length) {
        await Promise.all(regs.map((registration) => registration.unregister().catch(() => null)));
      }
    }

    try { localStorage.removeItem('msw.force'); } catch (_) {}
    try { localStorage.removeItem('msw'); } catch (_) {}
  } catch (_) {
  }
}
